import { createFileRoute } from '@tanstack/react-router'
import { EditAllergyPage } from '_/features/pets/ui/pages/edit-allergy-page'

const EditAllergyRoute = () => {
	const { petId, allergyId } = Route.useParams()
	return <EditAllergyPage petId={petId} allergyId={allergyId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/allergies/$allergyId/edit')({
	staticData: { title: 'allergies_edit_title' },
	component: EditAllergyRoute,
})
